import { ReactNode } from "react";
import { Tooltip } from "@/vendor/Forge/dist";

interface Props {
  id: string;
  text: string | ReactNode;
  textTooltip: string;
}

const TextWithTooltip = ({ id, text, textTooltip }: Props) => {
  if (!text) return null;
  return (
    <Tooltip id={`text-tooltip-${id}`} text={textTooltip}>
      {text}
    </Tooltip>
  );
};

export default TextWithTooltip;
